import React from "react";

import { useDownloadDocumentContent } from "@planzone/view-models";
import { Window } from "@common/window";
import { Loader } from "@common/loader";
import { Props } from "./types";
import { DocxRenderer } from "./docxRenderer";
import { ZipRenderer } from "./zipRenderer";
import { DefaultRenderer } from "./defaultRenderer";
import styles from "./styles.scss";

function isDocx(mimeType: string) {
  return [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword",
  ].includes(mimeType);
}

function isZip(mimeType: string) {
  return [
    "application/zip",
    "application/x-rar-compressed",
    "application/x-7z-compressed",
    "application/x-tar",
    "application/gzip",
    "application/x-bzip2",
    "application/x-xz",
    "application/x-lzip",
    "application/zstd",
    "application/gzip",
    "application/x-gzip",
    "application/x-bzip2",
    "application/bzip2",
    "application/x-xz",
    "application/x-xz-compressed",
    "application/x-lzip",
    "application/lzip",
    "application/zstd",
    "application/zstandard",
    "application/lha",
    "application/x-lha",
    "application/x-stuffit",
    "application/x-compactpro",
    "application/x-aix-toolbox",
  ].includes(mimeType);
}

function Preview({ document, close }: Props) {
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    file,
    downloadDocumentContent,
  } = useDownloadDocumentContent(document);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      downloadDocumentContent({ document });
  }, [document.uri]);

  return (
    <Window close={close}>
      <div className={styles.preview}>
        {isRequestPending ? (
          <div className={styles.loader}>
            <div>
              <Loader />
            </div>
          </div>
        ) : isDocx(document.mimeType) ? (
          <DocxRenderer document={document} file={file} />
        ) : isZip(document.mimeType) ? (
          <ZipRenderer document={document} file={file} close={close} />
        ) : (
          <DefaultRenderer document={document} file={file} />
        )}
      </div>
    </Window>
  );
}

export { Preview };
